export const ER_DUP_ENTRY = 'ER_DUP_ENTRY';
export const AUTHORIZATION_REQUIRED = 'AUTHORIZATION_REQUIRED';